import React from 'react';

interface DisclaimerProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  name?: string;
}

// Any link inside disclaimer copy must be styled explicitly at its call site
// (see DISCLAIMER_LINK_CLASS_NAME in utils/disclaimerContent.tsx) rather than
// relying on this component to find and style <a> tags on its callers'
// behalf. An earlier version of this component walked its children with
// React.cloneElement to inject underline styling onto any raw <a> element it
// found, which worked while disclaimer copy was authored as literal JSX
// fragments. Once disclaimer copy moved to <Trans> (required for bilingual
// support), the real <a> tags live inside <Trans>'s rendered output, which
// this kind of prop-level child walk cannot see into — so the injection
// silently became a no-op for every consumer without any error or warning.
export default function Disclaimer({
  children,
  className = '',
  id,
  name
}: DisclaimerProps) {
  return (
    <div
      className={`text-sm text-gray-400 ${className}`}
      id={id}
      data-name={name}
    >
      {children}
    </div>
  );
}
